function expandDropdownMenuInDesktop() {
    // var mainHeaderContainer = document.querySelector(".shopify-section.section-header")
    var desktopHeader = document.querySelector(".desktop-header")
    var headerDropdownContent = desktopHeader.querySelector(".dropdown-content")
    var modalOverlay = headerDropdownContent.querySelector(".modal-overlay")
    var l1MenuContainer = desktopHeader.querySelector(".l1-menu")
    var l1MenuItems = desktopHeader.querySelectorAll(".l1-menu .l1-menu-item")
    var dropdownMenu = desktopHeader.querySelector(".dropdown-menu")
    var l2MenuContent = desktopHeader.querySelector(".hidden-l2-menu-content")
    
    // Expand L2 menu on L1 menu hover
    l1MenuItems.forEach((menuItem) => {
        menuItem.addEventListener("mouseover", () => {
            
            var itemIndex = menuItem.dataset.menuIndex

            var targetL2Menu = l2MenuContent.querySelector(`[data-parent-menu-index="${itemIndex}"]`);
            // if there's no targetL2Menu, close any open dropdown and exit
            if (!targetL2Menu) {
                headerDropdownContent.classList.remove("active");
                dropdownMenu.classList.remove("active");
                return;
            }

            dropdownMenu.innerHTML = targetL2Menu.outerHTML
            dropdownMenu.classList.add("active");
            headerDropdownContent.classList.add("active");
        })
    });

    // Deactivate expanded menu on model-overlay hover
    modalOverlay.addEventListener("mouseover", () => {
        
        headerDropdownContent.classList.remove("active");
        dropdownMenu.classList.remove("active");
    });

    // Close dropdown when mouse leaves the dropdown menu
    l1MenuContainer.addEventListener("mouseleave", (event) => {
        // Check if the mouse is not moving to L2 menu
        let isMovingToL2 = false;
        if (dropdownMenu.contains(event.relatedTarget)) {
            isMovingToL2 = true;
        }

        if (!isMovingToL2) {
            headerDropdownContent.classList.remove("active");
            dropdownMenu.classList.remove("active");
        }
    });
}

// Function to make the header sticky at scroll point zero
function makeHeaderStickyDesktop() {
    var mainHeaderContainer = document.querySelector(".shopify-section.section-header");

    window.addEventListener("scroll", () => {
        if (window.scrollY > 0) {
            mainHeaderContainer.classList.add("sticky");
        } else {
            mainHeaderContainer.classList.remove("sticky");
        }
    });
}

function expandMenuDrawerInMobile() {
    var mobileHeader = document.querySelector(".mobile-header")

    // -----------------------------------------
    // Open and Close menu drawer
    // -----------------------------------------
    var menuDrawer = mobileHeader.querySelector(".menu-drawer")
    var menuOpenButton = mobileHeader.querySelector(".drawer-open-button")
    var menuCloseButtons = mobileHeader.querySelectorAll(".drawer-close-button")
    var drawerOverlay = mobileHeader.querySelector(".menu-drawer .drawer-overlay")
    
    menuOpenButton.addEventListener("click", () => {
        menuDrawer.classList.add("active")
    })

    menuCloseButtons.forEach((closeButton) => {
        closeButton.addEventListener("click", () => {
            menuDrawer.classList.remove("active");
        });
    })

    drawerOverlay.addEventListener("click", () => {
        menuDrawer.classList.remove("active");
    })
    // -----------------------------------------
    // End open and Close menu drawer
    // -----------------------------------------


    // -----------------------------------------
    // Expand L2 menu on L1 selection
    // -----------------------------------------
    var drawerContent = mobileHeader.querySelector(".drawer-content")
    var l1MenuItems = mobileHeader.querySelectorAll(".l1-menu-item")
    var l2MenuContent = mobileHeader.querySelector(".hidden-l2-menu-content")
    var mainPage = mobileHeader.querySelector(".main-page.l1-menu-content")
    var expandingPage = mobileHeader.querySelector(".expanding-page.l2-menu-content")
    var expandingPageHeader = expandingPage.querySelector(".page-title")
    var l2MenuContainer = mobileHeader.querySelector(".expanding-page .l2-menu-container")
    var l2MenuBackButton = mobileHeader.querySelector(".expanding-page .back-button")

    l1MenuItems.forEach((l1MenuItem) => {
        l1MenuItem.addEventListener("click", () => {
            var l1MenuIndex = l1MenuItem.dataset.l1MenuIndex
            var targetL2Menu = l2MenuContent.querySelector(`[data-parent-l1-menu-index="${l1MenuIndex}"]`)

            if (!targetL2Menu)
                return

            var l1MenuItemTitle = l1MenuItem.querySelector(".item-title span").textContent
            l2MenuContainer.innerHTML = targetL2Menu.outerHTML
            expandingPageHeader.textContent = l1MenuItemTitle
            setL2MenuEventListeners()
            drawerContent.scrollTo({ left: expandingPage.offsetLeft, behavior: 'smooth' });
        });
    });

    l2MenuBackButton.addEventListener("click", () => {
        drawerContent.scrollTo({ left: mainPage.offsetLeft, behavior: 'smooth' });
    });
    // -----------------------------------------
    // End expand L2 menu on L1 selection
    // -----------------------------------------


    
    // -----------------------------------------
    // Expand L3 menu on L2 selection
    // -----------------------------------------
    function setL2MenuEventListeners(){
        var l2MenuItems = expandingPage.querySelectorAll(".l2-menu-item")

        l2MenuItems.forEach((l2MenuItem) => {
            l2MenuItem.addEventListener("click", () => {
                var l2MenuIndex = l2MenuItem.dataset.l2MenuIndex
                var targetL3Menu = expandingPage.querySelector(`.l3-menu[data-parent-l2-menu-index="${l2MenuIndex}"]`)

                if (!targetL3Menu)
                    return

                if (targetL3Menu.classList.contains("expanded")){
                    targetL3Menu.classList.remove("expanded")
                    l2MenuItem.classList.remove("expanded")
                }else{
                    targetL3Menu.classList.add("expanded")
                    l2MenuItem.classList.add("expanded")
                }
                
            })
        })
    }
    // -----------------------------------------
    // End expand L3 menu on L2 selection
    // -----------------------------------------

}

// Initialize both functions
expandDropdownMenuInDesktop();
makeHeaderStickyDesktop();

expandMenuDrawerInMobile();

// Mirror desktop cart count bubble into mobile bubble
(function syncCartBubbles() {
  const desktopBubble = document.getElementById('cart-icon-bubble');
  const mobileHeader = document.querySelector('.mobile-header');
  if (!desktopBubble || !mobileHeader) return;

  function copyCount() {
    const mobileBubble = mobileHeader.querySelector('.cart-count-bubble');
    if (!mobileBubble) return;
    mobileBubble.innerHTML = desktopBubble.innerHTML;
  }

  // Initial copy on load
  copyCount();

  // Observe changes to desktop bubble (AJAX updates)
  try {
    const observer = new MutationObserver(copyCount);
    observer.observe(desktopBubble, { childList: true, subtree: true });
  } catch (e) {
    // ignore it
  }
})();